export const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function buildYearOptions(startYear = 2023) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = startYear; year <= currentYear; year += 1) {
    years.push(year);
  }
  return years;
}

export const chartTooltipStyle = {
  backgroundColor: "#1E293B",
  borderColor: "#243354",
  borderWidth: 1,
  titleColor: "#fff",
  bodyColor: "rgba(255,255,255,0.8)",
  padding: 10,
  cornerRadius: 8,
};

export const chartScales = {
  x: {
    grid: { display: false },
    ticks: {
      color: "rgba(255,255,255,0.25)",
      font: { size: 10, family: "Outfit, Inter, sans-serif" },
    },
    border: { display: false },
  },
  y: {
    grid: { color: "rgba(255,255,255,0.06)" },
    ticks: {
      color: "rgba(255,255,255,0.25)",
      font: { size: 10, family: "Outfit, Inter, sans-serif" },
    },
    border: { display: false },
  },
};

export function YearSelect({ years, value, onChange }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value, 10))}
      className="text-[11px] text-white/40 px-3 py-1 rounded-lg bg-[#1a2744] border border-[#243354] outline-none cursor-pointer"
    >
      {years.map((year) => (
        <option key={year} value={year} className="bg-[#0F172A] text-white">
          {year}
        </option>
      ))}
    </select>
  );
}
